function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.25L5 4.75L1.5 1.25",
    stroke: "#7F7F7F",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      mixBlendMode: "luminosity"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.25L5 4.75L1.5 1.25",
    stroke: "#3D3D3D",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.0efa341cecfc307f49f4cd5633659406.svg";
export { ForwardRef as ReactComponent };